import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Typography,} from "@mui/material";

import {
  Card,
  Grid,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Pagination,
  Box,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";
const CustomStepper = ({ title }) => {
  return (
    <Box mb={3} display="flex" justifyContent="center">
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", color: "#2e7fae", textAlign: "center" }}
      >
        {title}
      </Typography>
    </Box>
  );
};
function Threshold() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [thresholdData, setThresholdData] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1); // MUI starts from 1
  const [totalPages, setTotalPages] = useState(0);
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token;

  // 🔹 Fetch Current Threshold
  const fetchThreshold = async () => {
    try {
      const secretKey = await fetchSecretKey();

      const response = await axios.get(
        `/api/patient-threshold/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setThresholdData(decrypted);
      }
    } catch (error) {
      // toast.error("Failed to fetch threshold data");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Fetch History
  const fetchHistory = async (thresholdId, pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();

      const response = await axios.get(
        `/api/patient-threshold/history/${thresholdId}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);

        setHistoryData(decrypted.content || []);
       setCurrentPage(decrypted.number + 1);
          setTotalPages(decrypted.totalPages);
        setHistoryOpen(true);
      }
    } catch (error) {
      toast.error("Failed to fetch history");
    }
  };

  useEffect(() => {
    fetchThreshold();
  }, [id]);

  const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const buttonStyle = {
    borderColor: "#1565C0",
    color: "#1565C0",
    textTransform: "none",
    borderRadius: 2,
    fontSize: "13px",
    px: 2.5,
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground />

      <MDBox mt={4} px={3}>
        <Card sx={{ borderRadius: 4, padding: 4 }}>
          <MDTypography variant="h5" fontWeight="600" mb={3}>
            Patient Threshold Settings
          </MDTypography>

          {thresholdData ? (
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Card
  sx={{
    borderRadius: 4,
    padding: 4,
    backgroundColor: "#F3F8FF", // very very light blue
  }}
>
                  <MDTypography variant="body2" mb={2}>
                    <strong>Date:</strong>{" "}
                    {thresholdData.createdAt
                      ? new Date(thresholdData.createdAt).toLocaleDateString()
                      : ""}
                  </MDTypography>

                  <Divider sx={{ mb: 2 }} />

                  <MDTypography variant="body2">
                    <strong>Systolic:</strong>{" "}
                    {thresholdData.systolicLow} - {thresholdData.systolicHigh}
                  </MDTypography>

                  <MDTypography variant="body2">
                    <strong>Diastolic:</strong>{" "}
                    {thresholdData.diastolicLow} - {thresholdData.diastolicHigh}
                  </MDTypography>

                  <MDTypography variant="body2">
                    <strong>Glucose:</strong>{" "}
                    {thresholdData.glucoseLow} - {thresholdData.glucoseHigh}
                  </MDTypography>

                  {thresholdData.doctorid && (
                    <MDTypography variant="body2">
                      <strong>Doctor:</strong>{" "}
                      {thresholdData.doctor?.name}
                    </MDTypography>
                  )}

                  {thresholdData.ccid && (
                    <MDTypography variant="body2">
                      <strong>Care Coordinator:</strong>{" "}
                      {thresholdData.careCoordinator?.name}
                    </MDTypography>
                  )}

                
                </Card>
              </Grid>
            </Grid>
          ) : (
            <MDTypography>
              {loading ? "Loading..." : "No Data Available"}
            </MDTypography>
          )}
            <MDBox mt={2} display="flex" gap={1}>
                    <Button
                      variant="outlined"
                      sx={buttonStyle}
                      onClick={() => navigate(`/AddThreshold/${id}`)}
                    >
                      Create
                    </Button>

                    <Button
                      variant="outlined"
                      sx={buttonStyle}
                      onClick={() =>
                        navigate(`/UpdateThreshold/${id}`)
                      }
                    >
                      Update
                    </Button>

                    <Button
                      variant="outlined"
                      sx={buttonStyle}
                      onClick={() => fetchHistory(thresholdData.patientid)}
                    >
                      History
                    </Button>
                  </MDBox>
        </Card>
      </MDBox>

      {/* 🔹 HISTORY POPUP */}
      <Dialog
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        fullWidth
        maxWidth="lg"
      >
        <br/>
       
          <CustomStepper title="Threshold History"/>

        <DialogContent>
          <Table sx={{ border: "1px solid #ccc" }}>
            <TableHead>
                     <TableRow sx={{ backgroundColor: "#1A237E" }}>

              <TableCell sx={{ border: "1px solid #ccc", color: "#fff", fontWeight: 600 , minWidth: 150 }}>
      Date
    </TableCell>
    <TableCell sx={{ border: "1px solid #ccc", color: "#fff", fontWeight: 600 , minWidth: 150 }}>
      Systolic
    </TableCell>
    <TableCell sx={{ border: "1px solid #ccc", color: "#fff", fontWeight: 600, minWidth: 150  }}>
      Diastolic
    </TableCell>
    <TableCell sx={{ border: "1px solid #ccc", color: "#fff", fontWeight: 600, minWidth: 150  }}>
      Glucose
    </TableCell>
    <TableCell sx={{ border: "1px solid #ccc", color: "#fff", fontWeight: 600 , minWidth: 150 }}>
      Doctor
    </TableCell>
    <TableCell sx={{ border: "1px solid #ccc", color: "#fff", fontWeight: 600 , minWidth: 150 }}>
      Care Coordinator
    </TableCell>
  </TableRow>
           

            <TableBody>
              {historyData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {row.createdAt
                      ? new Date(row.createdAt).toLocaleDateString()
                      : ""}
                  </TableCell>

                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {row.systolicLow} - {row.systolicHigh}
                  </TableCell>

                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {row.diastolicLow} - {row.diastolicHigh}
                  </TableCell>

                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {row.glucoseLow} - {row.glucoseHigh}
                  </TableCell>

                 <TableCell sx={{ border: "1px solid #ccc" }}>
  {row.doctorName ? row.doctorName : "-"}
</TableCell>

<TableCell sx={{ border: "1px solid #ccc" }}>
  {row.careCoordinatorName ? row.careCoordinatorName : "-"}
</TableCell>
                </TableRow>
              ))}
            </TableBody>
             </TableHead>
          </Table>
            <Box mt={2} display="flex" justifyContent="center">
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="success"
                         sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "4px",
                  color: "#1A237E",          // Text color
                  borderColor: "#1A237E",    // Border color if outlined
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#1A237E", // Selected background
                  color: "#fff",                 // Selected text color
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#1A237E", // Slight hover effect
                },
              }}
                      />
                    </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setHistoryOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Threshold;